export class CampoSpecificoFascicoloVO {
  nome: string;

  valore: string[];

  codice: string;

  tipoDato: string;

}
